import { asyncRequest, baseUrl } from 'utils/http/api';
import { ENDPOINT_URLS } from 'constants/endpointUrls';
import { RestaurantProfileFormData } from 'app/pages/RestaurantSettings/WebsiteBuilder/RestaurantProfile';

export const getRestaurantProfileSettingsCall = async () => {
  return await asyncRequest(
    {
      method: 'GET',
      baseURL: baseUrl,
      url: ENDPOINT_URLS.RESTAURANT.SETTINGS.WEBSITE_BUILDER.RESTAURANT_PROFILE,
    },
    true,
  );
};

export const getRestaurantProfileAttributesConfigCall = async () => {
  return await asyncRequest(
    {
      method: 'GET',
      baseURL: baseUrl,
      url: ENDPOINT_URLS.RESTAURANT.SETTINGS.WEBSITE_BUILDER.RESTAURANT_ATTRIBUTES_CONFIG,
    },
    true,
  );
};

export const updateRestaurantProfileSettingsCall = async (data: RestaurantProfileFormData) => {
  return await asyncRequest(
    {
      method: 'PUT',
      baseURL: baseUrl,
      url: ENDPOINT_URLS.RESTAURANT.SETTINGS.WEBSITE_BUILDER.RESTAURANT_PROFILE,
      data,
    },
    true,
  );
};
